<template>
  <div class="campaign-list elevation-2">
    <UCardHeader :header="header" v-model="searchTerm" action="search" />
    <UActionList
      v-if="campaigns.length"
      :columns="columns"
      :items="campaigns"
      :search-term="searchTerm"
      data-tid="item-list"
      @create="routeToCampaign('new')"
      @select="routeToCampaign($event.id)"
    />
    <UEmptyList
      v-else
      title="Create Your First Campaign"
      subtitle="Use campaigns to manage campaign parameters, create tracking links and persist history."
      @createAction="routeToCampaign('new')"
    />
  </div>
</template>

<script>
import UCardHeader from "@/components/UCardHeader";
import UActionList from "@/components/UActionList";
import UEmptyList from "@/components/UEmptyList";

export default {
  components: {
    UCardHeader,
    UActionList,
    UEmptyList,
  },
  props: {
    campaigns: {
      type: Array,
      required: true,
    },
    routeToCampaign: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      header: "Campaigns",
      searchTerm: "",
      columns: [
        { text: "Name", align: "left", value: "name", width: "60%" },
        {
          text: "Updated",
          align: "left",
          value: "updated_at",
          timestamp: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.campaign-list {
  @include card();
}
</style>
